import { color, getBreaks, getDistinctValues, IDatalayerMapInstance, IDatalayerViewerFactory, isNumber, NumericValuesViewer, ZoneTextLocation } from "../../omnia";
import { LayerTypeId } from "../../types";

const ecScanColors: number[][] = [
    [0xff, 0xff, 0],
    [0xcf, 0x9b, 0],
    [0x9f, 0x4f, 0],
    [0x6f, 0x1b, 0],
    [0x40, 0, 0],
]

export class EcScanViewer extends NumericValuesViewer {

    public static getFactory(): IDatalayerViewerFactory {

        var factory: IDatalayerViewerFactory = {

            typeId: LayerTypeId.EcScan,
            name: "EC scan",

            createViewer: (layer) => new EcScanViewer(layer),

        }

        return factory;
    }

    private pointDataDivisions: {
        Number: number,
        Min: number,
        Max: number,
    }[];

    constructor(_layer: IDatalayerMapInstance) {

        super(_layer, {
            colorProvider: new color.NumericRangeColorProvider(ecScanColors),
            units: "mS/m",
        });

    }

    refresh() {
        super.refresh();
        this.setupDivisionsFromPoints();
    }

    private setupDivisionsFromPoints(numberDivisions: number = 5) {

        if (this._layer.points) {

            var values = this._layer.points.map(p => p[2]);
            values = getDistinctValues(values, v => v);
            values = values.sort((v1, v2) => v1 - v2);

            var breaks = getBreaks(values, numberDivisions);

            this.pointDataDivisions = [];

            for (var i = 0; i < (breaks.length - 1); i++) {
                this.pointDataDivisions.push({
                    Number: i + 1,
                    Min: breaks[i],
                    Max: breaks[i + 1]
                });
            }

        }

    }

    getPointFillColor(feature: any): any {

        if (this.pointDataDivisions && feature) {

            var value = feature.get("data")["value"];

            var div = this.pointDataDivisions.find(d => d.Max >= value);

            if (div) {
                return ecScanColors[div.Number - 1];
            }

        }

        return [255, 255, 255, 0.75];

    }

    getClusterPointFillColor(values: any[]): any {

        if (this.pointDataDivisions && values && (values.length > 0)) {

            var value = values.reduce((v1, v2) => v1 + v2);
            value /= values.length;

            var div = this.pointDataDivisions.find(d => d.Max >= value);

            if (div) {
                return ecScanColors[div.Number - 1];
            }

        }

        return [255, 255, 255, 0.75];

    }

    getValueText(value: number, location: ZoneTextLocation): string {

        var text = "";

        if (isNumber(value) && this._layer.datalayer.Divisions) {
            var div = this._layer.datalayer.Divisions.find(d => d.Number == value);
            if (div) text = div.Min + " - " + div.Max;
        }

        text = this.addUnits(text)

        return text;

    }

}
